.numberScore {
    border: none;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    font-family: Lora;
    //transform: translate(0, 3px);
}

.percent {
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    vertical-align: bottom;
    font-family: Lora;
    position: relative;
    top: -2px;
    left: 1px;
}
